import React from 'react';

const Ads: React.FC = () => {
  // クリック時の計測処理
  const handleAdClick = () => {
    // 実際に計測ツールを入れる場合はここに記述します
    console.log('広告がクリックされました: https://kimino-yukue.com/');
  };

  return (
    <div className='p-ads'>
      <a 
        href="https://kimino-yukue.com/" 
        target="_blank"
        rel="noopener noreferrer"
        onClick={handleAdClick}   // クリック時に計測を実行
        className="p-ads__link"   // 必要に応じてスタイル調整用クラスを追加
        style={{ display: 'block', cursor: 'pointer' }} // 画像全体をクリック可能にする
      >
        <img src='/img/common/pr-251226.png' alt='広告バナー' />
      </a>
    </div>
  );
};

export default Ads;
